import { render, staticRenderFns } from "./BetaDiversityDissimilarityWidget.vue?vue&type=template&id=b3f65f74&scoped=true"
import script from "./BetaDiversityDissimilarityWidget.vue?vue&type=script&lang=js"
export * from "./BetaDiversityDissimilarityWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f65f74",
  null
  
)

export default component.exports